import React from "react";
import "../styles/howItWorks.css";

function WorkflowSteps({ steps }) {
  return (
    <div className="how-steps">
      {steps.map((step, index) => (
        <div className="how-step" key={step.title || step}>
          <div className="how-step-marker">
            <span className="mono-tag">{String(index + 1).padStart(2, "0")}</span>
            {index !== steps.length - 1 && <span className="how-step-line" />}
          </div>
          <div className="how-step-body">
            {step.title ? (
              <>
                <h3 className="how-step-title">{step.title}</h3>
                <p className="how-step-detail">{step.detail}</p>
              </>
            ) : (
              <p className="how-step-detail">{step}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default WorkflowSteps;
